import { post } from "../api/_utils";

export default class FormesterAnalytics {
  constructor(session, formUUID) {
    this.session = session;
    this.formUUID = formUUID;

    this.timeSpent = {};
    this.startTime = 0;

    this.currentPage = null;

    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.trackEvent = this.trackEvent.bind(this);
    // NOTE: we don't want to track beacons for now.
    // need more clarity from product on tracking and showing and then we'll renable it.
    // this.beaconId = setInterval(() => {
    //   this.sendBeacon();
    // }, 5000);
  }

  // we can probably also see if we want to use action cable for this?
  // this will make api call to your analytics endpoint at regular interval
  // sending data to backend
  async sendBeacon() {
    if (Object.keys(this.timeSpent).length === 0) return; // No data to send
    await post(
      `/forms/${this.formUUID}/analytics/${this.session}/track.json`,
      this.timeSpent,
    );
  }

  stopBeacon() {
    clearInterval(this.beaconId);
  }

  handleFocusIn(e) {
    this.startTime = new Date().getTime();
  }

  handleFocusOut(e) {
    const fieldId = e.target.getAttribute("data-uuid");
    // trackTime(fieldId);
    // now we are going to work on drop offs
    // which means we want to track which is the last question the user has seen
    // trackDropOff(fieldId);
  }

  /**
   * Track events like initial form views, page navigation
   * @param {string} pageId - Page ID to track
   * @param {string} eventType - "form_view" or "page_navigate" (default)
   */
  async trackEvent(pageId, eventType = "page_navigate") {
    this.currentPage = pageId;

    const payload = {
      current_page_id: this.currentPage,
      event_type: eventType,
    };

    try {
      await post(
        `/forms/${this.formUUID}/analytics/${this.session}/event.json`,
        payload,
      );
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Tracks the time spent on a given field
   * Does not work with radio and checkboxes
   * @param {uuid} fieldId
   */
  // this does not work for non input and textarea component
  // time spend outside of a field is not tracked
  trackTime(fieldId) {
    const currentTime = new Date().getTime();
    const timeSpent = currentTime - this.startTime; // Calculating time spent on field
    if (this.timeSpent[fieldId]) {
      this.timeSpent[fieldId] = this.timeSpent[fieldId] + timeSpent;
    } else {
      this.timeSpent[fieldId] = timeSpent;
    }
  }
}
